module.exports = __webpack_public_path__ + "static/avatar-1d816cbdf65b7cd24fbfdb7e53e9dd7c.jpg";